module.exports = __webpack_public_path__ + "img/list40.34800aa0.jpeg";